/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import React from 'react';
import { Accordion, Spinner } from 'react-bootstrap';
import {
  ListItemsComp,
  TextComp,
  HtmlComp,
  TableComp,
  CheckLists,
} from './components';

import { MultiColList } from '../MultiColList';

import { TimelineMercury } from '@vlinder-web/timeline-mercury-widget-react';
import { CheckedItems } from '../CheckedItems';
import { IconListComp } from '../IconList';
import { MediaListComp } from '../MediaList';

import * as S from './styles';
import { MediaCarousel } from '../MediaCarousel';

export interface accordionItems {
  type:
    | 'text'
    | 'markup'
    | 'list'
    | 'multi-col-list'
    | 'timeline'
    | 'check-list'
    | 'icon'
    | 'media';
  title: string;
  data: any;
  isStatus?: boolean;
  statusTitle?: any;
  statusbg?: any;
  statusColor?: any;
  styleProps: any;
  isButton?: boolean;
  buttonText?: any[];
}

export interface IAccordionProps {
  data: accordionItems[];
  timelineCardClick?(id: string): void;
  _onCarouselImageClick?(item: any): void;
  onButtonClick?(item: any): void;
  [key: any]: any;
}

export const AccordionComp = (props: IAccordionProps) => {
  const {
    data,
    onButtonClick,
    timelineCardClick,
    _onCarouselImageClick,
    ...rest
  } = props;
  console.log(data);
  const _getBody = (item) => {
    switch (item?.type) {
      case 'list':
        return <ListItemsComp listItems={item?.data} />;
      case 'timeline':
        return (
          <TimelineMercury items={item?.data} onItemClick={timelineCardClick} />
        );
      case 'text':
        return <TextComp {...item} />;
      case 'markup':
        return <HtmlComp {...item} />;
      case 'multi-col-list':
        return <MultiColList {...item} />;
      case 'check-list':
        return <CheckLists {...item} />;
      case 'icon':
        return <IconListComp {...item} />;
      case 'media':
        return <MediaListComp {...item} />;
      case 'media-carousel':
        return (
          <MediaCarousel
            {...item}
            onCarouselImageClick={_onCarouselImageClick}
          />
        );
      default:
        return null;
    }
  };
  const _getAccordionBody = (item) => {
    if (Array.isArray(item)) {
      return <>{item?.map((_item) => _getBody(_item))}</>;
    }
    return _getBody(item);
  };

  const _renderAccordion = (item: listItems) => {
    const renderButtons = () => {
      if (Array.isArray(item)) {
        return item?.some(
          (subItem) => subItem?.isButton && Array.isArray(subItem.buttonText)
        ) ? (
          <div style={{ padding: '0 1rem' }}>
            {item.map((subItem, index) =>
              subItem?.isButton && Array.isArray(subItem.buttonText)
                ? subItem.buttonText.map((text, btnIndex) => (
                    <button
                      key={`${index}-${btnIndex}`}
                      className="btn btn-primary mt-2 me-2"
                      onClick={() =>
                        console.log(
                          `Button clicked for ${subItem.title} - ${text}`
                        )
                      }
                    >
                      {text || 'Click Me'}
                    </button>
                  ))
                : null
            )}
          </div>
        ) : null;
      } else if (item?.isButton && Array.isArray(item.buttonText)) {
        return (
          <div style={{ marginTop: '1rem', padding: '0 1rem' }}>
            {item.buttonText.map((text, btnIndex) => (
              <button
                key={btnIndex}
                className="btn btn-primary mt-2 me-2"
                onClick={() =>
                  onButtonClick && onButtonClick({ ...item, buttonText: text })
                }
              >
                {text || 'Click Me'}
              </button>
            ))}
          </div>
        );
      }
      return null;
    };

    const _item = Array.isArray(item) && item?.length > 0 ? item?.[0] : item;
    console.log(_item);
    return (
      <S.AccordionComponent
        defaultActiveKey={_item?.title}
        style={S.AccordionStyle}
        className="mt-2"
      >
        <Accordion.Item eventKey={_item?.title}>
          <Accordion.Header style={S.HeaderStyle}>
            <h6 className="fw-bold p-2 d-flex align-items-center gap-2 m-0">
              {_item?.title}
              {_item?.isStatus && _item?.statusTitle && (
                <span
                  style={{
                    backgroundColor: _item.statusBg,
                    color: _item.statusColor,
                    borderRadius: '6px',
                    padding: '2px 8px',
                    fontSize: '0.8rem',
                    fontWeight: 500,
                  }}
                >
                  {_item.statusTitle}
                </span>
              )}
            </h6>
          </Accordion.Header>

          <hr />
          <Accordion.Body style={{ paddingBottom: '1rem' }}>
            {_getAccordionBody(item)}
            {renderButtons()}
          </Accordion.Body>
        </Accordion.Item>
      </S.AccordionComponent>
    );
  };

  return (
    <>
      {Array.isArray(data) &&
        data?.map((item: listItems) => {
          return <>{_renderAccordion(item)}</>;
        })}
    </>
  );
};

AccordionComp.defaultProps = {};
